import { Component, h, useState } from "@lukekaalim/act"
import { html } from "@lukekaalim/act-web"

import classes from './index.module.css';
import { assetURLs } from "../../assets";
import { LabeledInput } from "./input";
import { useFrontendCore, useFrontendServices } from "@kosmod/core";
import { AuthState } from "../../hooks";

export type SignUpProps = {
  onSignUpComplete(): void,
  onClickLogin(): void,

  auth: AuthState,
}

export const SignUp: Component<SignUpProps> = ({ onSignUpComplete, onClickLogin, auth }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const { site } = useFrontendServices();

  return h(html.form, { classList: [classes.authenticateForm, classes.signUp], async onSubmit(event) {
    event.preventDefault();
    await auth.signup({ username, password, email });
    onSignUpComplete();
  }, }, [

    h(html.img, { className: classes.heroLogo, src: assetURLs.kosmodTransparentLogo, onClick: () => site.navigate({ path: '/' }) }),

    h(html.p, { className: classes.instructions }, [
      h(html.div, {}, `Create a new`),
      h(html.strong, {}, `Kosmod Account`)
    ]),

    h(LabeledInput, {
      label: '👤 username',
      name: 'username',
      placeholder: 'luke.kaalim',
      value: username,
      onInput() {
        setUsername(this.value)
      },
    }),
    h(LabeledInput, {
      label: '📨 email',
      type: 'email',
      placeholder: 'luke@gmail.com',
      value: email,
      onInput() {
        setEmail(this.value)
      },
    }),
    h(LabeledInput, {
      label: '🔒 password',
      type: 'password',
      placeholder: '************',
      value: password,
      onInput() {
        setPassword(this.value)
      },
    }),
    h(html.input, { type: 'submit' }),

    h(html.div, {}, [
      h(html.div, {}, `already have an account?`),
      h(html.button, { onClick: onClickLogin, type: 'button' }, 'Login')
    ]),
  ])
}